function DazMintSigned(url, address) {
    this.signingUrl = url;
    this.address = address;
    this.contract = new window.dazeth.web3.eth.Contract(window.dazContracts["IMintSigned"], address);
    this.enabled = false;
    this.maxPerTransaction = 0;
    this.initialized = false;
}

DazMintSigned.prototype.init = async function () {
    try {
        this.enabled = await this.contract.methods.publicMintEnabled().call();
        this.maxPerTransaction = await this.contract.methods.maxMintPerTrx().call()
    } catch (e) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "init",
                data: {},
                error: e
            }
        }));
        throw e;
    }
    this.initialized = true;
    return {
        enabled: this.enabled,
        initialized: this.initialized,
        maxPerTransaction: this.maxPerTransaction,
    }
}

DazMintSigned.prototype.data = function (token, qty, nonce, captcha, data) {
    return {
        from: dazethutil.me(),
        token,
        qty,
        nonce,
        captcha,
        ...data,
    }
}

DazMintSigned.prototype.checkEnabled = function () {
    if (!this.enabled || !this.initialized) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "pre_mint",
                data: {
                    enabled: this.enabled,
                    initialized: this.initialized
                },
                error: "not enabled"
            }
        }));
        throw "not enabled";
    }
}

DazMintSigned.prototype.mintCost = async function (id, quantity) {
    if (quantity <= 0) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "cost",
                data: {token: id, qty: quantity},
                error: "token quantity invalid"
            }
        }));
    }
    return this.contract.methods['mintCost(uint256,uint256)'](id, quantity).call({from: dazethutil.me()});
}


DazMintSigned.prototype.mint = async function (data) {
    this.checkEnabled();

    data = Object.assign({token: 0, block: 0, price: 0, from: null, nonce: null, captcha: null, qty: 0}, data)
    const price = await this.mintCost(data.token, data.qty);
    data.price = dazeth.web3.utils.fromWei(price, 'ether');
    data.block = await dazeth.web3.eth.getBlockNumber();
    if (data.nonce === null || data.nonce === "" || data.captcha === null || data.captcha === "" || data.block === 0 || data.qty === 0) {
        window.dispatchEvent(new CustomEvent("mint_error", {
            detail: {
                when: "mint",
                data: data,
                error: "invalid mint data"
            }
        }));
        throw "invalid mint data";
    }

    return fetch(this.signingUrl, {
        method: 'POST',
        body: (new URLSearchParams(data)).toString(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }).then(async response => {
        if (!response.ok) {
            throw await response.text();
        }
        return response.json();
    }).then(async result => {
        return {
            price: data.price,
            nonce: data.nonce,
            token: data.token,
            qty: data.qty,
            block: data.block,
            hash: result.Hash,
            signature: result.Signature,
            captcha: result.Captcha,
        }
    }).catch(async txt => {
        let err = "";
        try {
            err = JSON.parse(txt);
        } catch (e) {
            err = {error: txt};
        }
        window.dispatchEvent(new CustomEvent("mint_error", {detail: {when: "sign", error: err.error}}));
        throw err.error;
    });
}

DazMintSigned.prototype.complete = async function (data, mint) {
    return await this.contract.methods.mintSigned(data.nonce, data.token, data.qty, data.block, data.captcha, data.hash, data.signature).send({
        from: dazethutil.me(),
        value: dazeth.web3.utils.toWei(data.price.toString(), 'ether')
    }).on('transactionHash', (hash) => mint.onTransactionHash(data, hash)).catch((err) => {
        throw err;
    });
}
